<template>
  <b-container fluid>
    <b-row class="m-3">
      <b-col>
        <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>
        <FullCalendar
          class='demo-app-calendar'
          ref="fullCalendar"
          :options="calendarOptions"
          >
            <template v-slot:eventContent='arg'>
              <div class="mr-2 d-inline">
                <b>{{ arg.timeText }}</b>
              </div>
              <div class="mr-2 d-inline">
                <i>{{ arg.event.title }}</i>
              </div>
            </template>
          </FullCalendar>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import Api from '@/api/Api'

export default {
  data () {
    return {
      loading: false,
      events: [],
      current: null,
      calendarPlugins: [ // plugins must be defined in the JS
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin // needed for dateClick
      ],
      calendarWeekends: true,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin
        ],
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        weekends: true,
        initialView: 'dayGridMonth',
        events: this.loadEvents,
        eventClick: this.handleEventClick,
        eventClassNames: this.renderEvent
      }
    }
  },
  methods: {
    loadEvents (info, successCallback) {
      var vm = this
      Api().get(`Course?pageSize=100&dateRangeStart=${moment(info.start.valueOf()).format()}&dateRangeEnd=${moment(info.end.valueOf()).format()}`)
        .then((r) => {
          const events = r.data.items.filter(i => !i.title.toLowerCase().startsWith('template -')).map((i) => {
            return {
              id: i.id,
              title: (i.title + ' ' + i.trainingEventId) + (i.daysOfWeek ? ` (${i.daysOfWeek.split('|').join(', ')})` : ''),
              start: moment(i.startDateTime).toDate(),
              end: moment(i.endDateTime).toDate(),
              data: i
            }
          })
          successCallback(events)
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    handleEventClick (info) {
      this.$router.push({ name: 'Course', params: { id: info.event.id } })
    },
    renderEvent (info) {
      return [ '' ]
    }
  },
  components: {
    FullCalendar
  }
}
</script>

<style>

</style>
